export const formatarMoeda = (valor) => {
  return valor ? valor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0,00";
};

export const formatarMoedaDolar = (valor) => {
  return valor ? valor.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0.00";
};